module.exports = __webpack_public_path__ + "static/media/BETYAR_logo_header.62544c11.png";